function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Col as DefaultCol, Container as DefaultContainer, Row as DefaultRow, ScreenClassRender } from 'react-grid-system';
const SizeMap = {
  xs: 'xs',
  sm: 'sm',
  md: 'md',
  lg: 'lg',
  xl: 'xl',
  xxl: 'xxl'
};
const screenClasses = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl']; // const SIZES = R.values(SizeMap)

export const Grid = props => {
  const {
    style = {},
    col,
    xs,
    sm,
    md,
    lg,
    xl,
    xxl
  } = props,
        rest = _objectWithoutProperties(props, ["style", "col", "xs", "sm", "md", "lg", "xl", "xxl"]);

  const type = col ? 'col' : 'row';
  const [styleMap, hasFlexProps] = React.useMemo(() => {
    var _ref, _ref2, _ref3, _ref4;

    const hasFlexProps = (_ref = (_ref2 = (_ref3 = (_ref4 = xs !== null && xs !== void 0 ? xs : sm) !== null && _ref4 !== void 0 ? _ref4 : md) !== null && _ref3 !== void 0 ? _ref3 : lg) !== null && _ref2 !== void 0 ? _ref2 : xl) !== null && _ref !== void 0 ? _ref : xxl;
    return [hasFlexProps ? {
      xs,
      sm,
      md,
      lg,
      xl,
      xxl
    } : {}, hasFlexProps];
  }, [xs, sm, md, lg, xl, xxl]);
  const ComponentType = ComponentTypeMap[type];
  return hasFlexProps ? /*#__PURE__*/React.createElement(ScreenClassRender, {
    render: screenClass => {
      var _style$visible, _styleMap$screenClass;

      let selectedStyle = {};
      screenClasses.forEach((size, index) => {
        if (screenClasses.indexOf(screenClass) >= index) {
          var _styleMap$size;

          selectedStyle = (_styleMap$size = styleMap[size]) !== null && _styleMap$size !== void 0 ? _styleMap$size : selectedStyle;
        }
      });
      const combinedStyle = StyleSheet.flatten([style, selectedStyle]);
      return (
        /*#__PURE__*/
        // @ts-ignore
        React.createElement(ComponentType // @ts-ignore
        , _extends({
          style: combinedStyle,
          xs: combinedStyle.size // @ts-ignore
          ,
          visible: (_style$visible = style === null || style === void 0 ? void 0 : style.visible) !== null && _style$visible !== void 0 ? _style$visible : (_styleMap$screenClass = styleMap[screenClass]) === null || _styleMap$screenClass === void 0 ? void 0 : _styleMap$screenClass.visible // size={combinedStyle.size}

        }, rest))
      );
    }
  }) :
  /*#__PURE__*/
  // @ts-ignore
  React.createElement(ComponentType, _extends({}, rest, {
    style: style // @ts-ignore
    ,
    xs: style === null || style === void 0 ? void 0 : style.size // @ts-ignore
    ,
    visible: style === null || style === void 0 ? void 0 : style.visible
  }));
};
export const Container = props => /*#__PURE__*/React.createElement(DefaultContainer, _extends({
  fluid: true
}, props, {
  style: _objectSpread(_objectSpread({}, StyleSheet.flatten(props === null || props === void 0 ? void 0 : props.style)), {}, {
    display: (props === null || props === void 0 ? void 0 : props.visible) !== false ? 'flex' : 'none',
    marginLeft: 0,
    marginRight: 0
  })
}));
export const Col = props => /*#__PURE__*/React.createElement(DefaultCol, _extends({
  nogutter: true
}, props, {
  style: StyleSheet.flatten([props === null || props === void 0 ? void 0 : props.style, {
    display: (props === null || props === void 0 ? void 0 : props.visible) !== false ? 'flex' : 'none',
    flexDirection: 'column'
  }])
}));
export const Row = props => /*#__PURE__*/React.createElement(Container, _extends({
  fluid: true
}, props), /*#__PURE__*/React.createElement(Col, _extends({
  nogutter: true
}, props), /*#__PURE__*/React.createElement(DefaultRow, _extends({
  nogutter: true
}, props, {
  style: StyleSheet.flatten([props === null || props === void 0 ? void 0 : props.style, {
    display: (props === null || props === void 0 ? void 0 : props.visible) !== false ? 'flex' : 'none',
    flexDirection: 'row'
  }])
}))));
const ComponentTypeMap = {
  grid: Container,
  row: Row,
  col: Col,
  view: View
};